export default __webpack_public_path__ + "static/icon-3-6-cc40d2cf8a155aba26f3dbf040baa0e8.png";